import React from "react";
import PropTypes from "prop-types";

import BreadcrumbList from "components/search/Breadcrumbs/BreadcrumbList";
import BreadcrumbSchema from "components/search/Breadcrumbs/BreadcrumbSchema";
import { Button } from "components/core/Button";
import { Chevron } from "components/core/Icons";
import navigate from "utils/navigate";

import "./Breadcrumbs.scss";

const Breadcrumbs = ({
	cityUrl,
	stateUrl,
	location,
	facilityUrl,
	allowTruncation,
	facilityName,
	isCLP,
	canonicalUrl,
	isSearchPage,
	breadcrumbList,
	className
}) => {
	const { state, fullState, preferredPlaceName } = location;

	const breadcrumbs = [...(breadcrumbList || [{ label: "Home", href: "/" }])];

	if (stateUrl) {
		breadcrumbs.push({
			label: fullState,
			name: state,
			href: stateUrl
		});
	}

	if (cityUrl) {
		breadcrumbs.push({
			label: preferredPlaceName,
			name: preferredPlaceName,
			href: cityUrl
		});
	}

	if (facilityUrl) {
		breadcrumbs.push({
			label: facilityName,
			name: facilityName,
			href: facilityUrl
		});
	}

	const previousBreadcrumb =
		breadcrumbs[breadcrumbs.length - 2] || breadcrumbs[0];

	const handleBackButtonClick = (previousBreadcrumbHref) => {
		navigate(previousBreadcrumbHref);
	};

	return (
		<div className="breadcrumbs">
			<div>
				<Button
					theme="icon"
					onClick={() =>
						handleBackButtonClick(previousBreadcrumb.href)
					}
					className="back-button"
					title={`Navigate to ${previousBreadcrumb.label}`}
				>
					<Chevron
						fill="blue"
						rotate="left"
					/>
				</Button>
				<BreadcrumbList
					breadcrumbs={breadcrumbs}
					allowTruncation={allowTruncation}
					className={className}
				/>
			</div>
			{!isCLP && !isSearchPage && <BreadcrumbSchema breadcrumbs={breadcrumbs} isCLP={isCLP} canonicalUrl={canonicalUrl} />}
		</div>
	);
};

Breadcrumbs.defaultProps = {
	cityUrl: "",
	location: {},
	stateUrl: ""
};

Breadcrumbs.propTypes = {
	cityUrl: PropTypes.string,
	location: PropTypes.object,
	stateUrl: PropTypes.string,
	facilityUrl: PropTypes.string,
	allowTruncation: PropTypes.bool,
	facilityName: PropTypes.string,
	isSearchPage: PropTypes.bool,
	isCLP: PropTypes.bool,
	canonicalUrl: PropTypes.string,
	breadcrumbList: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			href: PropTypes.string.isRequired,
			name: PropTypes.string
		})
	),
	className: PropTypes.string
};

export default Breadcrumbs;
